/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import EnterpriseOrgScopedSearchBarGridItem from 'bundles/composable-page-header-enterprise/components/EnterpriseOrgScopedSearchBarGridItem';
import type { UseEnterpriseMyPageHeaderResult as MyEnterprisePageHeader } from 'bundles/composable-page-header-enterprise/contexts/EnterpriseMyPageHeaderContext';
import DefaultLoggedOutEnterpriseMobileMenuConfig from 'bundles/composable-page-header-enterprise/module-renderers/DefaultLoggedOutEnterpriseMobileMenuConfig';
import {
  getEnterpriseOrgLogo,
  getEnterpriseOrgLogoLabel,
  getLinkForOrgHome,
} from 'bundles/composable-page-header-enterprise/utils/enterpriseLogoUtils';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import MobileMenuIconGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuIconGridItem';

const styles = {
  fullContainer: css`
    flex-wrap: nowrap;
  `,
  leftSide: css`
    flex-wrap: nowrap;
  `,
  rightSide: css`
    flex-wrap: nowrap;
  `,
};

type Props = {
  pageHeaderData: MyEnterprisePageHeader;
  hideSearch?: boolean;
};

const LoggedOutOrgScopedEnterpriseMobileMainNav = ({ pageHeaderData, hideSearch }: Props) => {
  const { naptimeCurrentPageOrganization, naptimeChosenOrganization } = pageHeaderData;

  const currentOrganization = naptimeCurrentPageOrganization ?? naptimeChosenOrganization;

  const logo = currentOrganization ? [getEnterpriseOrgLogo(currentOrganization)] : [<CourseraHomeLogo key="1" />];

  const LogoComponent = (
    <HomeLogoGridItemModule
      href={currentOrganization ? getLinkForOrgHome(currentOrganization) : '/'}
      logos={logo}
      ariaLabel={currentOrganization ? getEnterpriseOrgLogoLabel(currentOrganization) : undefined}
    />
  );

  return (
    <MainNavigationWrapper>
      <Grid item container css={styles.fullContainer}>
        <Grid item container alignItems="center" css={styles.leftSide}>
          <MobileMenuIconGridItem
            menuConfig={<DefaultLoggedOutEnterpriseMobileMenuConfig />}
            homeLogo={LogoComponent}
          />
          {LogoComponent}
        </Grid>
        <Grid item container alignItems="center" justifyContent="flex-end" css={styles.rightSide}>
          {!hideSearch && (
            <EnterpriseOrgScopedSearchBarGridItem thirdPartyOrganizationSlug={currentOrganization?.slug} />
          )}
        </Grid>
      </Grid>
    </MainNavigationWrapper>
  );
};

export default LoggedOutOrgScopedEnterpriseMobileMainNav;
